var e=Object.freeze({services:[]});export{e as DEFAULT_SERVICE_CONFIG};
//# sourceMappingURL=DEFAULT_SERVICE_CONFIG.js.map
